<template>
  <v-container fluid>
    <div class="page-shell">
      <notification-dialog></notification-dialog>
      <land-batch-form v-if="canCreate || canUpdate" @saved="initialize" @cleared="selected = null"></land-batch-form>

      <v-card class="page-card">
        <v-toolbar color="primary" class="page-toolbar">
          <v-toolbar-title>Lotes</v-toolbar-title>
        </v-toolbar>

        <v-row class="pa-4" dense>
          <v-col cols="12" md="5">
            <v-card variant="tonal" class="land-list-card">
              <v-card-title class="text-subtitle-1">Fincas y lotes</v-card-title>
              <v-card-text v-if="!groupedLocations.length" class="text-medium-emphasis">
                Todavia no hay lotes cargados. Usa el formulario superior para crear el primero.
              </v-card-text>
              <v-list v-else density="comfortable" nav>
                <template v-for="location in groupedLocations" :key="location.id">
                  <v-list-subheader>{{ location.name }}</v-list-subheader>
                  <v-list-item
                    v-for="batch in location.children"
                    :key="`${location.id}-${batch.id}`"
                    :active="selected && selected.id === batch.id"
                    rounded="sm"
                    @click="selectBatch(batch, location)">
                    <template #prepend>
                      <v-icon>view_column</v-icon>
                    </template>
                    <v-list-item-title>{{ batch.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ batch.haAmount || 0 }} ha</v-list-item-subtitle>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </v-col>

          <v-col cols="12" md="7">
            <v-card variant="tonal" class="land-detail-card">
              <div v-if="!selected" class="empty-state">
                <v-icon size="40">view_column</v-icon>
                <div>Selecciona un lote para ver el detalle.</div>
              </div>
              <template v-else>
                <v-card-title>{{ selected.name }}</v-card-title>
                <v-card-text>
                  <v-row dense>
                    <v-col cols="12" sm="6">
                      <div class="detail-label">Finca</div>
                      <div>{{ selected.locationName }}</div>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <div class="detail-label">Hectareas</div>
                      <div>{{ selected.haAmount || 0 }}</div>
                    </v-col>
                    <v-col cols="12">
                      <div class="detail-label">Observaciones</div>
                      <div>{{ selected.note || 'Sin observaciones' }}</div>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions v-if="canUpdate || canDelete">
                  <v-btn v-if="canUpdate" color="primary" @click="edit(selected)">
                    <v-icon start>edit</v-icon>
                    Editar
                  </v-btn>
                  <v-btn v-if="canDelete" color="error" variant="tonal" @click="remove(selected)">
                    <v-icon start>delete</v-icon>
                    Borrar
                  </v-btn>
                </v-card-actions>
              </template>
            </v-card>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import AddEditLandBatchForm from './AddEditLandBatchForm'
import NotificationDialog from '../Common/NotificationDialog'

export default {
  name: 'LandBatch',
  components: {
    'land-batch-form': AddEditLandBatchForm,
    'notification-dialog': NotificationDialog
  },
  data: () => ({
    selected: null,
    batchesByLocation: []
  }),

  created () {
    this.initialize()
  },

  computed: {
    ...mapGetters(['isRefreshTableRequired']),
    ...mapGetters('authModule', ['hasPermission']),
    canCreate () { return this.hasPermission('catalog.lots.create') },
    canUpdate () { return this.hasPermission('catalog.lots.update') },
    canDelete () { return this.hasPermission('catalog.lots.delete') },
    ...mapGetters('landBatchModule', ['getBatchesByLocation']),
    groupedLocations () {
      return (this.batchesByLocation || [])
        .map(location => ({
          ...location,
          children: location.children || []
        }))
        .filter(location => location.children.length > 0)
    }
  },

  watch: {
    'isRefreshTableRequired': function (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.initialize()
      }
    }
  },

  methods: {
    initialize () {
      this.$store.dispatch('locationModule/getLocations')
      this.$store.dispatch('landBatchModule/getBatchesByLocation').then(() => {
        this.batchesByLocation = this.$store.getters['landBatchModule/getBatchesByLocation'] || []
      })
    },

    selectBatch (batch, location) {
      this.selected = {
        ...batch,
        parentId: location.id,
        locationName: location.name
      }
    },

    startNewLot () {
      this.selected = null
      this.$store.dispatch('landBatchModule/setSelectedItem', this.$store.getters['landBatchModule/getDefaultLandBatch'])
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },

    remove (item) {
      confirm(`Estas seguro de eliminar lote: ${item.name}?`) &&
        this.$store.dispatch('landBatchModule/removeLandBatch', item.id).then(result => {
          this.selected = null
          this.$store.dispatch('landBatchModule/setSelectedItem', this.$store.getters['landBatchModule/getDefaultLandBatch'])
          this.initialize()
        }).catch(error => console.log('There was an error trying to delete bathLand.' + error))
    },

    edit (item) {
      this.$store.dispatch('landBatchModule/setSelectedItem', item)
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>
<style scoped>
.land-list-card,
.land-detail-card {
  min-height: 320px;
}

.empty-state {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 12px;
  justify-content: center;
  min-height: 320px;
  text-align: center;
}

.detail-label {
  font-size: 0.78rem;
  opacity: 0.7;
  text-transform: uppercase;
}
</style>
